export const marginCalculatorFeatureKey = 'margin-calculator';
